import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b3896c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-tag-box" }
const _hoisted_2 = { class: "tag-title" }
const _hoisted_3 = { class: "ckecked-tag-box" }
const _hoisted_4 = { class: "tag-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('rightSidebar.baseTagTitle')), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noCheckedTagList, (tagItem) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          class: "tag base-tag",
          color: tagItem.tagColor,
          key: tagItem.tagId,
          onClick: ($event: any) => ($setup.add_manga_tag(tagItem))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('rightSidebar.ckeckedTagTitle')), 1 /* TEXT */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checkedTagList, (tagItem) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          class: "tag ckecked-tag",
          color: tagItem.tagColor,
          key: tagItem.tagId,
          closable: "",
          onClose: ($event: any) => ($setup.remove_tag(tagItem.mangaTagId))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "onClose"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}